import PaymentsEnrollmentPanelButton from '../../components/PaymentsEnrollmentPanelButton';
import { EnrollmentFlowType } from '../../types';
import { useEligibilityBinding } from 'growth-payments-core/eligibility/eligibilityBinding';
import { useHasStartedHSPaymentsApplication } from 'growth-payments-core/kyc/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const GoToProcessorPickerButton = props => {
  const [eligibility] = useEligibilityBinding();
  const {
    hasStartedHSPaymentsApplication,
    loading: hasStartedHSPaymentsApplicationLoading
  } = useHasStartedHSPaymentsApplication(eligibility);
  const shouldShowContinueEnrollmentCopy = !props.children && hasStartedHSPaymentsApplication;
  return /*#__PURE__*/_jsx(PaymentsEnrollmentPanelButton, Object.assign({
    "data-test-id": `go-to-processor-picker-button-${props.location}`,
    enrollmentType: EnrollmentFlowType.processorPicker,
    viewTrackingAction: "goToProcessorPickerViewed",
    clickTrackingAction: "goToProcessorPickerClicked",
    loading: props.loading || hasStartedHSPaymentsApplicationLoading
  }, props, {
    children: shouldShowContinueEnrollmentCopy ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "paymentsEnrollmentButton.native.continueEnrollment"
    }) : props.children
  }));
};
export default GoToProcessorPickerButton;